export default __webpack_public_path__ + "static/media/status-ok.ecc76c02.svg";